import { Injectable } from '@angular/core';
import { LibOptionValue } from 'daisy-design-system-front';
import { StationGnv, StationGnvList } from 'swagger-gen/gnvert-secured/models';

@Injectable({
  providedIn: 'root'
})
export class StationMapper {

  public convertToOptions(stations: StationGnvList): LibOptionValue<string>[] {
    return stations?.map(this.convertToOption) || [];
  }

  private convertToOption(station: StationGnv): LibOptionValue<string> {
      return ({label: station.name, value: station.uid});
  }

}
